/* eslint-disable react/display-name */

import { memo } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { buttons } from 'app/modules/translation';
import moment from 'moment';
import { Card, Col, Row } from 'react-bootstrap';
import { ArrowRight, Calendar3, ChevronDoubleRight, Infinity } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetAllReportVersions } from '../../reportVersion/hooks';
import { label } from '../../reportVersion/Translate/translation';
import { type ReportVersion } from '../../reportVersion/types';
interface Props {
  reportId: string;
}
const Index = memo((props: Props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const newFormVersion = () => {
    navigate('/taxes/manage/complementary/versions/' + props.reportId + '/create');
  };
  const { reportId } = props;
  const { data } = useGetAllReportVersions(reportId);

  return (
    <>
      <Row>
        <Col>
          <BtnToolbar cssClass="mt-0 mb-2">
            <BtnGroup>
              <></>
            </BtnGroup>
            <BtnGroup>
              <Button
                onClick={() => newFormVersion()}
                action={ButtonAction.new}
                text={buttons(t, 'newVersion')}
              />
            </BtnGroup>
          </BtnToolbar>
        </Col>
      </Row>
      {data &&
        data?.map((c: ReportVersion) => {
          return (
            <>
              <Row className="mb-3">
                <Col>
                  <Card>
                    <Card.Body>
                      <Card.Title className="text-primary">
                        <span>
                          {label('version')} {c.version}
                        </span>
                      </Card.Title>
                      <Row>
                        <Col xs={5} sm={5} className="text-center">
                          <div>
                            <Calendar3 size="32"></Calendar3>
                          </div>
                          <span>
                            {}
                            <span className="font-weight-bold">
                              {' '}
                              {moment(c.dateFrom).format('DD/MM/yyyy')}{' '}
                            </span>
                          </span>
                        </Col>
                        <Col xs={2} sm={2} className="text-center">
                          <ArrowRight size="32"></ArrowRight>
                        </Col>
                        <Col xs={5} sm={5} className="text-center">
                          <span>
                            {}
                            {c.dateTo && (
                              <div>
                                <div>
                                  <Calendar3 size="32"></Calendar3>
                                </div>

                                <span className="font-weight-bold">
                                  {moment(c.dateTo).format('DD/MM/yyyy')}{' '}
                                </span>
                              </div>
                            )}
                            {!c.dateTo && <Infinity size="32"></Infinity>}
                          </span>
                        </Col>
                      </Row>
                    </Card.Body>
                    <Card.Footer className="text-center py-1">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('/taxes/manage/complementary/versions/' + c.id + '/general');
                        }}
                      >
                        {t('common.label.edit')} <ChevronDoubleRight></ChevronDoubleRight>
                      </a>
                    </Card.Footer>
                  </Card>
                </Col>
              </Row>
            </>
          );
        })}
    </>
  );
});

export default Index;
